export enum SearchMode { Create, Modify }